
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-services",
      function () {
        return require("private-next-pages/all-services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-services"])
      });
    }
  